import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import LavorisService from "../../services/LavorisService";
import { TableActions } from "../../components/others/TableActions/index";
import { employeeAbsences } from "./Types/Absences.type";
import RequestAbsences from "../others/requestAbsences";
import EliminarModal from "../../components/others/EliminarModal";
import DetailsAbsences from "../others/detailsAbsenteeism";
import RequestAbsencesAlert from "../others/requestAbsencesAlert";
import DangerousZoneAlert from "../others/dangerousZoneAlert";
import { useModal } from "../../hooks";
import CoordinatesErrorModal from "../others/coordinatesErrorModal/coordinatesErrorModal";
import moment from "moment";
import { getCreatedDateToString } from "./getCreatedDate";
import { useAlert } from "../../hooks/useAlert";
import { useSelector } from "react-redux";
import { RootState } from "../../store/combineReducer";
import Tooltip, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';
import { GetOneAbsenceResponseService } from "../../services/Absences/Absences.type";
import { Badge, BadgeProps } from "@mui/material";
import exelReports from "../Results/exelReports";
import ChatbotCloseSessionMessage from "../others/chatbotModales/chatbotCloseSessionMessage";
import InfoOffcanvas from "../../components/others/InfoOffCanvas/InfoOffCanvas";
import InfiniteTable from "../../components/others/InfiniteTableComponent/IntiniteTableComponent";
import { SuccessModal } from "../../components/others/SuccessModal";
import "./absence.scss";
const CLOSE_SESSION_CHATBOT_MESSAGE = "closeSessionChatbotMessage";
const SUCCESS = 'succesPetition';

export const AbsencesRequest = () => {
  const reduxStore = useSelector((state: RootState) => state.user);
  const chosenRole: string = reduxStore?.currentRole;
  const controller = new AbortController();
  const signal = controller.signal;
  const [from, setFrom] = useState<string | null>(null);
  const [to, setTo] = useState<string | null>(null);
  const [fromFormatted, setFromFormatted] = useState<string>(moment().subtract(10, 'days').format('DD/MM/YYYY'));
  const [toFormatted, setToFormatted] = useState<string>(moment().add(10, 'days').format('DD/MM/YYYY'));
  const [hasMore, setHasMore] = useState(true);
  const [searchQuery, setSearcQuery] = useState<string | null>(null);
  const hasSearchQuery = searchQuery && searchQuery.length > 0
  const LavorisInstance = LavorisService.getInstance();
  const { closeModal, openModal, isActive } = useModal();
  const { showAlert } = useAlert();
  const [items, setItems] = useState({
    itemsPerPage: 40,
    page: 1,
  });
  const [searchParams, setSearchParams] = useSearchParams("");
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState<any[]>([]);
  const [loader, setLoader] = useState(false);
  const [selectedEmployee, setSelectedEmployee] = useState<employeeAbsences>();
  const status = 'Nueva Solicitud,Asignada';

  useEffect(() => {
    return () => {
      controller.abort();
    };
  }, [])

  const getAllAppointmentsCall = async () => {
    setLoader(true);
    try {
      const app = await LavorisInstance.AbsencesServices.getAbsencesRequested(
        //currentCompany, 
        items.itemsPerPage,
        {
          page: items.page,
          fromParam: fromFormatted,
          toParam: toFormatted,
          searchQuery: hasSearchQuery ? searchQuery : "",
          status
        },
        signal,
      )


      if (app.absenteesAppointments.length === 0) {
        //showAlert("No se encontraron registros");
        setHasMore(false);
        return;
      }


      // Obtén los IDs de las citas actuales en el estado
      const existingIds = new Set(data?.map(item => item.id));

      // Filtra las nuevas citas para agregar solo las que no están en el estado actual
      const uniqueAppointments = app.absenteesAppointments.filter(appointment => !existingIds.has(appointment.id));

      // Agrega nuevas citas únicas al estado
      setData(prevData => [...prevData, ...uniqueAppointments]);
      //Incrementa la página
      setItems(prev => ({ ...prev, page: prev.page + 1 }));
    } catch (e) {
      console.log(e);
      setHasMore(false);

    } finally {
      setLoader(false);
    }
  };

  const getAllAppointmentsRefreshTable = async () => {
    setLoader(true);
    try {
      const app = await LavorisInstance.AbsencesServices.getAbsencesRequested(
        //currentCompany, 
        items.itemsPerPage,
        {
          page: items.page,
          fromParam: fromFormatted,
          toParam: toFormatted,
          searchQuery: hasSearchQuery ? searchQuery : "",
          status
        },
        signal,
      )


      if (app.absenteesAppointments.length === 0) {
        //showAlert("No se encontraron registros");
        setHasMore(false);
        return;
      }


      setData([])
      setData(app.absenteesAppointments);
      //Incrementa la página
      setItems(prev => ({ ...prev, page: prev.page + 1 }));
    } catch (e) {
      console.log(e);
      setHasMore(false);

    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    getAllAppointmentsCall();
  }, [])

  const HtmlTooltip = styled(({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: '#f5f5f9',
      color: 'rgba(0, 0, 0, 0.87)',
      maxWidth: 220,
      fontSize: theme.typography.pxToRem(12),
      border: '1px solid #dadde9',
    },
  }));

  const StyledBadge = styled(Badge)<BadgeProps>(({ theme }) => ({
    '& .MuiBadge-badge': {
      right: -3,
      top: 13,
      border: `2px solid ${theme.palette.background.paper}`,
      padding: '0 4px',
      margin: '0  4px'
    },
  }));

  const fechaSolicitud = (rowData: GetOneAbsenceResponseService) => {
    if (!rowData) return 'No disponible'
    let fecha = getCreatedDateToString(rowData?.createdDate)[0];
    let hora = getCreatedDateToString(rowData?.createdDate)[1];
    return `${fecha}-${hora}`
  }

  const employeeAdrss = (rowData: GetOneAbsenceResponseService) => {
    if (!rowData) return 'No disponible'

    if (rowData?.not_at_home) {
      const altAdrs = rowData?.alternative_adrs?.trim()
      if (altAdrs) return altAdrs

      const chatbotAdrs = [rowData?.chatbot_actual_adress, rowData?.chatbot_additional_adress_info]
        .map((part) => part?.trim())
        .filter(Boolean)
        .join(', ')

      if (chatbotAdrs) return chatbotAdrs
      return 'No disponible'
    }

    return rowData?.fullAddress?.trim() || 'No disponible'
  }

  const giaSolicitud = (rowData: GetOneAbsenceResponseService) => {
    if (!rowData) return '---'
    const gia = rowData?.gia ? 'Si' : 'No'
    return (
      <span className={`${rowData.gia ? 'text-bg-success' : 'text-bg-danger'} badge rounded-pill `}>{gia}</span>
    )
  }

  data.sort((a, b) => {
    const createdDateA = new Date(a.createdDate);
    const createdDateB = new Date(b.createdDate);

    // Ordenar en orden descendente (de lo más reciente a lo más antiguo)
    return createdDateB.getTime() - createdDateA.getTime();
  });

  const appType = (rowData: any) => {
    if (rowData.type === 'Videollamada') return 'Telecontrol'
    if (rowData.type === 'Visita a Domicilio') return 'Control en Domicilio'
    if (rowData.type === 'Consulta en Lavoris') return 'Control en Consultorio Lavoris'
    if (rowData.type === 'Define Lavoris') return 'AA - Ausentismo Asistido'
    return !rowData?.type && 'Control en Consultorio Lavoris';
  }

  const HandleDeletion = async () => {
    try {
      setIsLoading(true);
      const rowId = searchParams.get("rowId") || "";
      const absentee = await LavorisInstance.Absences.GetAbsenceTurn(rowId);

      if (absentee && absentee.status === 'Asignada') {
        alert('El ausentismo ya fue asignado. Para cancelarlo comuníquese directamente con Lavoris. Gracias');
      } else if (absentee && absentee.gia && absentee.chatbot_id) {
        alert('El GIA ya comenzó. Para cancelarlo comuníquese directamente con Lavoris. Gracias');
      } else {
        await LavorisInstance.Absences.deleteAbsence(rowId);
      }
      closeModal("EliminateModal");
      getAllAppointmentsRefreshTable();
    } catch (err: any) {
      console.log(err);
      alert('Hubo un problema al momento de realizar la cancelación: ' + err?.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="absence-module-container">
      <div className="custom-header mt-4 pt-2">
        <div className="header-controls">
          {/* Search Section */}
          <div className="search-section">
            <div className="results-count d-inline-flex">
              <span className="count-number">{data.length}</span>
              <span className="count-label">items</span>
            </div>
          </div>

          {/* Actions Section */}
          <div className="actions-section">
            {!loader && (<>
              <button
                type="button"
                className="add-btn"
                onClick={() => {
                  setItems({
                    itemsPerPage: 20,
                    page: 1,
                  });
                  openModal("modalSolicitarAusentismo");
                }}
                title="Solicitar otras modalidades"
              >
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <path
                    d="M8 3.333v9.334M3.333 8h9.334"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                <span className="btn-text">Solicitar</span>
              </button>

              <button
                className="download-btn"
                onClick={() => exelReports(data, false)}
                title="Descargar reporte de todos los postulantes"
                disabled={data.length === 0}
              >

                <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <path
                    d="M14 10v2.667A1.333 1.333 0 0112.667 14H3.333A1.333 1.333 0 012 12.667V10M8 10.667L8 2M8 10.667l-2.667-2.666M8 10.667l2.667-2.666"
                    stroke="currentColor"
                    strokeWidth="1.3"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>

                <span className="btn-text">Excel</span>
              </button>
            </>

            )}
            <InfoOffcanvas title="INFORMACIÓN">
              <ul className="text-md p-auto m-auto">
                <li>- La tabla contiene todos las peticiones que esten como Nueva Solicitud y Asignadas.</li>
              </ul>
            </InfoOffcanvas>

          </div>
        </div>
      </div>

      <InfiniteTable
        data={data}
        height={400}
        loading={loader}
        hasMore={hasMore}
        columns={[
          {
            key: 'patientName',
            title: 'Apellido y Nombre',
            className: 'col-name',
            render: (value: any, row: any) =>
              row?.employee?.name.toUpperCase() || "No disponible"
          },
          {
            key: 'dni',
            title: 'DNI',
            className: 'col-dni',
            render: (value: any, row: any) =>
              row?.employee?.DNI || "----"
          },
          {
            key: 'direccion',
            title: 'Dirección',
            className: 'col-direccion',
            render: (value: any, row: any) =>
              employeeAdrss(row)
          },
          {
            key: 'fechaSolicitud',
            title: 'Fecha Solicitud',
            className: 'col-fecha-turno',
            render: (value: any, row: any) =>
              fechaSolicitud(row) || "No disponible"
          },
          {
            key: 'gia',
            title: 'AI',
            className: 'col-gia',
            render: (value: any, row: any) =>
              giaSolicitud(row) || "No disponible"
          },
          {
            key: 'type',
            title: 'Tipo',
            className: 'col-type',
            render: (value: any, row: any) =>
              appType(row) || ""
          },
          {
            key: 'estado',
            title: 'Estado',
            className: 'col-estado',
            render: (value: any, row: any) => row.status || "---"
          },
          {
            key: 'actions',
            title: 'Acciones',
            className: 'col-actions',
            render: (value: any, row: any) => (
              
                <div className="flex justify-center">
                  <div className="flex items-center justify-center gap-2">

                    <TableActions
                      type="View"
                      onClick={() => {
                        setSelectedEmployee(row);
                        openModal("modalDetalleAusentismo", row.id);
                      }}
                    />

                    {(row?.gia && !row?.chatbot_session_closed) && (
                      <TableActions
                        type="Phone"
                        title={row?.chatbot_id && row?.chatbot_message_state !== 'closing' ? 'Comenzado' : row?.chatbot_id && row?.chatbot_message_state === 'closing' ? 'Finalizado correctamente' : 'Sin acción'}
                        color={row?.chatbot_id && row?.chatbot_message_state !== 'closing' ? 'orange' : row?.chatbot_id && row?.chatbot_message_state === 'closing' ? 'green' : ''}
                        onClick={() => { }}
                      />
                    )}

                    {(row?.gia && row?.chatbot_session_closed && row?.chatbot_id) && (
                      <TableActions
                        type="Cancel Phone"
                        title="Chatbot cancelado (Ver)"
                        color="red"
                        onClick={() => openModal(CLOSE_SESSION_CHATBOT_MESSAGE, row?.id)}
                      />
                    )}

                    {(row?.status === "Nueva Solicitud" && !row?.chatbot_id) && (
                      <TableActions
                        type="Delete"
                        onClick={() => {
                          setItems({
                            itemsPerPage: 20,
                            page: 1,
                          });
                          setSelectedEmployee(row);
                          openModal("EliminateModal", row?.id);
                        }}
                      />
                    )}
                  </div>
                </div>
              
            )
          }
        ]}
        onLoadMore={getAllAppointmentsCall}
      />


      {isActive("modalSolicitarAusentismo") && (
        <RequestAbsences
          refreshFunction={() => getAllAppointmentsRefreshTable()}
          urlTittle={"modalSolicitarAusentismo"}
          toggleModal
        />
      )}

      {isActive("modalAlertaSolicitarAusentismo") && (
        <RequestAbsencesAlert
          toggleModal
          urlTittle="modalAlertaSolicitarAusentismo"

        />
      )}

      {isActive("modalAlertaZonaPeligrosa") && (
        <DangerousZoneAlert
          toggleModal
          urlTittle="modalAlertaZonaPeligrosa"
          onClose={() => {
            closeModal("modalAlertaZonaPeligrosa");
            closeModal("modalSolicitarAusentismo");
            getAllAppointmentsRefreshTable();
          }}
        />
      )}

      {isActive("modalDetalleAusentismo") && (
        <DetailsAbsences
          toggleModal
          urlTittle={"modalDetalleAusentismo"}
          patient={selectedEmployee}
          onClose={() => closeModal("modalDetalleAusentismo")}

        />
      )}

      {isActive("EliminateModal") && (
        <EliminarModal
          toggleModal
          name={selectedEmployee?.employee.name || ""}
          isLoading={isLoading}
          handleDeletion={() => HandleDeletion()}
          urlTittle={"EliminateModal"}
        />
      )}

      {isActive("modalCoordinatesError") && (
        <CoordinatesErrorModal
          show
          urlTittle="modalCoordinatesError"
          onClose={() => closeModal("modalCoordinatesError")}
        />
      )}

      {isActive(CLOSE_SESSION_CHATBOT_MESSAGE) && (
        <ChatbotCloseSessionMessage
          show
          urlTittle={CLOSE_SESSION_CHATBOT_MESSAGE}
          onClose={() => closeModal(CLOSE_SESSION_CHATBOT_MESSAGE)}
        />
      )}

      {isActive(SUCCESS) && (
        <SuccessModal
          show
          urlTittle={SUCCESS}
          modalTitle={'SOLICITUD CREADA EXITOSAMENTE.'}
          modalSubtitle={''}
          onClose={() => { closeModal(SUCCESS) }}
        />
      )}
    </div>
  )
};





